const isValidLocale = (messages, locale) => {
    return Object.keys(messages.value).includes(locale);
};

export const useBrowserLocale = (i18n, defaultLocale) => {
    const language = window.navigator.userLanguage || window.navigator.language;

    if (isValidLocale(i18n.messages, language)) {
        return language;
    }

    return defaultLocale;
};
